import { createProductSdk } from '@b2ag/utils/src/esmParser'
import { buildCallerId } from '@b2ag/utils/src/caller-id'
import { useAuthService } from '@b2ag/auth'
import { useLogger } from '@b2ag/utils/src/useLogger'
import { getConfig } from './config'
import ProductService from './services/product.service'
import { i18n } from '@b2ag/locale'
import type { InvivoLocale } from '@invivodf/locale'

const accessTokenSource = () => useAuthService().getAccessToken()
const logger = useLogger()
const callerId = buildCallerId()

const { productApiHost } = getConfig()

export const productApiClient = createProductSdk(`${productApiHost}`, {
  callerId,
  accessTokenSource,
  logger,
  localeSource: () => i18n.locale as InvivoLocale,
})

export const productService = new ProductService(productApiHost, productApiClient)
